export default __webpack_public_path__ + "static/media/markerCampus.9f973247.png";